export const LabelText: Record<string, string> = {
  ALLOWANCE_LINK_TITLE: 'Provide business allowances',
  BENEFITS_SUBTITLE: 'Upgrade your plan and get access to',
  BENEFITS_TITLE: 'Want to explore more benefits?',
  BENEFIT_LINE_1: 'Gift cards',
  BENEFIT_LINE_2: 'Company contract',
  BENEFIT_LINE_3: 'Zero admin fee',
  BENEFIT_LINE_4: 'Food and grocery allowances',
  BENEFIT_LINE_5: 'pandapro subscriptions',
  BENEFIT_LINE_6: 'Monthly invoicing',
  BENEFIT_LINE_7: 'Employee & perk management',
  BENEFIT_LINE_8: 'Dedicated support',
  DISCLAIMER_INFO:
    'We’ll review your request on an individual basis, according on foodpanda’s criteria. A plan upgrade is not guaranteed.',
  GC_LINK_TITLE: 'Send business gift cards',
  LINKS_TITLE: 'What you can do with us',
  PAGE_ACTION_BUTTON: 'Send request',
  PAGE_TITLE: 'Upgrade your plan',
  PANDAPRO_LINK_TITLE: 'Supercharge with pandapro',
  SEND_BUTTON: 'Send gift card',
  SUCCESSFUL_REQUEST_TITLE: 'We’ve got your request',
  UPGRADE_BUTTON: 'Request for an upgrade'
};
